import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import "./GuestHeader.css";
import Logo from "../../../assets/Images/Docusafe_logo.webp";
import { IoGlobeOutline, IoChevronDown } from "react-icons/io5";

const GuestHeader = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);

  const featuresRef = useRef(null);
  const resourcesRef = useRef(null);
  const languageRef = useRef(null);

  const languages = [
    { code: "en", name: "English", flag: "en" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "ja", name: "日本語", flag: "🇯🇵" },
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "de", name: "Deutsch", flag: "🇩🇪" },
    { code: "nl", name: "Nederlands", flag: "🇳🇱" },
  ];

  useEffect(() => {
    const currentLang = languages.find((lang) => lang.code === i18n.language);
    if (currentLang) setSelectedLanguage(currentLang.name);
  }, [i18n.language]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const clickOutside = (e) => {
      if (
        !featuresRef.current?.contains(e.target) &&
        !resourcesRef.current?.contains(e.target) &&
        !languageRef.current?.contains(e.target)
      ) {
        setIsLanguageOpen(false);
      }
    };

    document.addEventListener("mousedown", clickOutside);
    return () => document.removeEventListener("mousedown", clickOutside);
  }, []);

  const handleLanguageSelect = (lang) => {
    setSelectedLanguage(lang.name);
    i18n.changeLanguage(lang.code);
    setIsLanguageOpen(false);
  };

  return (
    <nav className="navbar navbar-light bg-white shadow-sm">
      <div className="guest-container guest-header">
        {/* LOGO */}
        <NavLink className="navbar-brand d-flex align-items-center" to="/">
          <div className="logo-wrapper">
            <img src={Logo} className="docusafe_logo" alt="logo" />
          </div>
        </NavLink>

        {/* MOBILE LANGUAGE */}
        {isMobile && (
          <div className="mobile-language-wrapper" ref={languageRef}>
            <div className="language-selector mobile">
              <button
                className="language-button"
                onClick={() => setIsLanguageOpen(!isLanguageOpen)}
              >
                <IoGlobeOutline className="globe-icon" />
                <span className="language-text">{selectedLanguage}</span>
                <IoChevronDown
                  className={`dropdown-arrow-guest ${isLanguageOpen ? "open" : ""
                    }`}
                />
              </button>

              {isLanguageOpen && (
                <div className="language-dropdown-grid mobile">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      className={`language-option-grid ${selectedLanguage === lang.name ? "active" : ""
                        }`}
                      onClick={() => handleLanguageSelect(lang)}
                    >
                      <span className="flag-icon">{lang.flag}</span>
                      <span className="language-name">{lang.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* MENU */}
        <div className={`navbar-collapse ${isMenuOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center nav-res">
            {/* ⭐ BECOME PARTNER (DESKTOP) */}
            {!isMobile && (
              <>
                <li className="nav-item me-3">
                  <NavLink to="/product" className="guest-menu-link">
                    Product
                  </NavLink>
                </li>
                <li className="nav-item me-3">
                  <NavLink to="/become-a-partner" className="guest-menu-link">
                    Become Partner
                  </NavLink>
                </li>
              </>
            )}
            {/* DESKTOP LANGUAGE */}
            {!isMobile && (
              <li className="nav-item language-nav-item" ref={languageRef}>
                <div className="language-selector desktop">
                  <button
                    className="language-button"
                    onClick={() => setIsLanguageOpen(!isLanguageOpen)}
                  >
                    <IoGlobeOutline className="globe-icon" />
                    <span className="language-text">{selectedLanguage}</span>
                    <IoChevronDown
                      className={`dropdown-arrow-guest ${isLanguageOpen ? "open" : ""
                        }`}
                    />
                  </button>

                  {isLanguageOpen && (
                    <div className="language-dropdown-grid">
                      {languages.map((lang) => (
                        <button
                          key={lang.code}
                          className={`language-option-grid ${selectedLanguage === lang.name ? "active" : ""
                            }`}
                          onClick={() => handleLanguageSelect(lang)}
                        >
                          <span className="flag-icon">{lang.flag}</span>
                          <span className="language-name">{lang.name}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </li>
            )}



            {/* ⭐ BECOME PARTNER (MOBILE) */}
            {isMobile && (
              <>
                <li className="nav-item mt-3 w-100">
                  <NavLink
                    to="/product"
                    className="guest-menu-link w-100 d-block text-center py-2"
                  >
                    Product
                  </NavLink>
                </li>
                <li className="nav-item mt-3 w-100">
                  <NavLink
                    to="/become-a-partner"
                    className="guest-menu-link w-100 d-block text-center py-2"
                  >
                    Become Partner
                  </NavLink>
                </li>
              </>
            )}

            {/* REGISTER BUTTON (DESKTOP) */}
            {!isMobile && (
              <li className="nav-item ms-3">
                <NavLink
                  to="/sign-up"
                  className="btn btn-primary guest-register-btn"
                >
                  Sign Up
                </NavLink>
              </li>
            )}



            {/* REGISTER BUTTON (MOBILE) */}
            {isMobile && (
              <li className="nav-item mt-3 w-100">
                <NavLink
                  to="/sign-up"
                  className="btn btn-primary w-100 guest-register-btn"
                >
                  Sign Up
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default GuestHeader;
